export default __webpack_public_path__ + "static/media/solar.38aacd45.jpg";